import { MassBroadCastDTO } from '../service/broadcasts.interface';

export const initialValues: MassBroadCastDTO = {
    title: 'Название рассылки',
    segmentation: null,
    chat_ids: [],
    send_at: null,
    status: null,
    type: null,
    timeSelect: null,
    text: '',
    image: null,
    linksArray: [],
};
